// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Inténtelo de nuevo con una fecha completa como la siguiente: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Grupo',
  chart_labelSeries: () => 'Serie',
  chart_labelValue: () => 'Valor',
  checkboxSet_requiredMessageDetail: () => 'Necesaria',
  checkbox_requiredMessageDetail: () => 'Necesaria',
  close: () => 'Cerrar',
  collection_noData: () => 'No hay datos que mostrar.',
  collection_selectAllRows: () => 'Seleccione todas las filas',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Seleccione la fila ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'No se puede ordenar',
  collection_sortEnabled: () => 'Se puede ordenar',
  confirmation: () => 'Confirmación',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' de ' + p['totalCount'],
  dataVisualization_noData: () => 'No hay datos que mostrar',
  dataVisualization_stateSelected: () => 'Seleccionado',
  dataVisualization_stateUnselected: () => 'No seleccionado',
  error: () => 'Error',
  expandableList_expandCollapseInstructionText: () =>
    'Utilice las teclas de flecha para ampliar y reducir',
  expandableList_groupCollapse: () => 'Reducido',
  expandableList_groupExpand: () => 'Ampliado',
  filePicker_addFiles: () => 'Agregar archivos',
  filePicker_dropzonePrimaryText: () => 'Arrastrar y Soltar',
  filePicker_dropzoneSecondaryText: () => 'Seleccione un archivo o suelte uno aquí',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Seleccione o suelte archivos aquí',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'No puede cargar archivos del tipo: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Cargue los archivos de uno en uno',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'No puede cargar archivos del tipo ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'desconocido',
  formControl_clear: () => 'Borrar',
  formControl_day: () => 'Día',
  formControl_helpAvailable: () => 'Ayuda disponible',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Ha alcanzado el límite de ' +
    ((
      {
        one: new Intl.NumberFormat('es').format(p['CHARACTER_LIMIT']) + ' carácter',
        many: new Intl.NumberFormat('es').format(p['CHARACTER_LIMIT']) + ' de caracteres'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('es').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('es').format(p['CHARACTER_LIMIT']) + ' caracteres') +
    '.',
  formControl_loading: () => 'Cargando',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Longitud máxima ' + p['MAX_LENGTH'] + ' superada.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Quedan ' + p['CHARACTER_COUNT'] + ' caracteres.',
  formControl_month: () => 'Mes',
  formControl_readOnly: () => 'Solo lectura',
  formControl_requiredMessageDetail: () => 'Introduzca un valor.',
  formControl_year: () => 'Año',
  gantt_labelDate: () => 'Fecha',
  gantt_labelEnd: () => 'Fin',
  gantt_labelLabel: () => 'Etiqueta',
  gantt_labelRow: () => 'Fila',
  gantt_labelStart: () => 'Inicio',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. No se ha encontrado ninguna sección que coincida.',
  indexer_keyboardInstructionText: () => 'Entre para seleccionar valor.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Entre ' + p['FROM_SECTION'] + ' y ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Toque dos veces y mantenga pulsado para cambiar a modo de gestos y, a continuación, arrastre hacia arriba o hacia abajo para ajustar el valor.',
  info: () => 'Información',
  inputDateMask_date_cleared: () => 'Fecha borrada',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Vaciar',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'aaaa',
  inputNumber_converterParseError: () => 'Introduzca un número.',
  inputNumber_decrease: () => 'Disminuir',
  inputNumber_increase: () => 'Aumentar',
  inputPassword_hidden: () => 'Contraseña oculta',
  inputPassword_hide: () => 'Ocultar contraseña',
  inputPassword_show: () => 'Mostrar Contraseña',
  list_suggestion: () => 'Sugerencia',
  messageToast_allMessagesClosed: () =>
    'Se han cerrado todos los mensajes de notificación del sistema.',
  message_close: () => 'Cerrar',
  message_confirmation: () => 'Correcto',
  message_error: () => 'Error',
  message_info: () => 'Información',
  message_navigationFromMessagesRegion: () =>
    'Zona de entrada de mensajes. Pulse F6 para volver al elemento enfocado anterior.',
  message_navigationToMessagesRegion: () =>
    'La zona de mensajes tiene mensajes nuevos. Pulse F6 para navegar a la zona de mensajes más reciente.',
  message_warning: () => 'Advertencia',
  noData_message: () => 'No hay elementos para mostrar',
  overflowItemLabel: () => 'Más separadores',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'En curso',
  radio_helpForRadio: () => 'Ayuda para botón de radio',
  radio_requiredMessageDetail: () => 'Seleccione un valor.',
  selectMultiple_apply: () => 'Aplicar',
  selectMultiple_back: () => 'Atrás',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Pulse Retroceso o Suprimir para eliminar el valor seleccionado.',
  selectMultiple_selectedValues: () => 'Valores seleccionados',
  selectMultiple_showSelectedValues: () => 'Solo se muestran los valores seleccionados.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valores seleccionados.',
  select_addToList: () => 'Agregar a la Lista',
  select_addToListAvailable: () => 'Agregar a la lista disponible',
  select_moreSearchOptions: () => 'Más opciones de búsqueda',
  select_moreSearchOptionsAvailable: () => 'Más opciones de búsqueda disponibles',
  select_noMatchesFound: () => 'No se ha encontrado ninguna coincidencia.',
  select_oneMatchFound: () => 'Se ha encontrado una coincidencia',
  select_requiredMessageDetail: () => 'Seleccione un valor.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Se han encontrado ' + p['TOTAL_SIZE'] + ' coincidencias',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Se han encontrado ' + p['TOTAL_SIZE'] + ' coincidencias o más',
  selector_selected: () => 'Casilla de control activada',
  selector_unselected: () => 'Casilla de control no activada',
  tabBarNavigationList_removeCueText: () => 'Se puede eliminar',
  timeComponent_tooltipZoomIn: () => 'Ampliar',
  timeComponent_tooltipZoomOut: () => 'Reducir',
  train_current: () => 'Actual',
  train_message_type: () => 'Tipo de Mensaje',
  train_not_visited: () => 'No visitado',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Paso ' + p['currentStep'] + ' de ' + p['numberOfSteps'],
  train_visited: () => 'Visitado',
  userAssistance_learnMore: () => 'Más información',
  userAssistance_required: () => 'Necesaria',
  viz_drillable: () => 'Explorable',
  warn: () => 'Advertencia'
};
export default bundle;
